"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/watchListService',["require", "exports", "routing/mainRouter", "controllers/watchListController", "models/userIdentityModel"], function (require, exports, mainRouter, watchListController, userIdentityModel) {
    "use strict";

    var WatchListService = function () {
        function WatchListService() {
            _classCallCheck(this, WatchListService);
        }

        _createClass(WatchListService, [{
            key: "savePolicyToWatchList",
            value: function savePolicyToWatchList(policyId, brokerPolicyId, reason, name, coverStartDate, coverEndDate, brokerPolicyHolderId) {
                return watchListController.savePolicyToWatchList({
                    environment: mainRouter.router.environmentId(),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    name: name,
                    reason: reason,
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate,
                    brokerPolicyHolderId: brokerPolicyHolderId
                });
            }
        }, {
            key: "getWatchedPolicies",
            value: function getWatchedPolicies() {
                return watchListController.getWatchedPolicies();
            }
        }, {
            key: "removePolicyFromWatchList",
            value: function removePolicyFromWatchList(policyId, brokerPolicyId, brokerPolicyHolderId, policyHolderFullName, fromTile) {
                return watchListController.removePolicyFromWatchList({
                    environment: mainRouter.router.environmentId(),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    policyHolderFullName: policyHolderFullName,
                    fromTile: fromTile,
                    brokerPolicyHolderId: brokerPolicyHolderId
                });
            }
        }, {
            key: "isWatching",
            value: function isWatching(policyId, brokerPolicyId) {
                return watchListController.isWatching({
                    environment: mainRouter.router.environmentId(),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId()
                });
            }
        }, {
            key: "updateWatchReason",
            value: function updateWatchReason(policyId, brokerPolicyId, reason, brokerPolicyHolderId, policyHolderFullName) {
                return watchListController.updateWatchReason({
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    reason: reason,
                    brokerPolicyHolderId: brokerPolicyHolderId,
                    policyHolderFullName: policyHolderFullName
                });
            }
        }]);

        return WatchListService;
    }();

    var watchListService;
    watchListService = new WatchListService();
    return watchListService;
});
//# sourceMappingURL=watchListService.js.map;
